import { MENU_SCRAPING } from '../../constants'

const getMenuScrapingBreadcrumbItemByTaskId = menuScrapingTaskId => ({
  path: `/tasks/menu-scraping/${menuScrapingTaskId}`,
  type: MENU_SCRAPING,
  name: 'Menu Scraping',
})

export default getMenuScrapingBreadcrumbItemByTaskId
